import { render, staticRenderFns } from "./item-body.vue?vue&type=template&id=4faba08f&scoped=true&"
import script from "./item-body.vue?vue&type=script&lang=ts&"
export * from "./item-body.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faba08f",
  null
  
)

export default component.exports